<template>
  <div class="maintenance-error">
    <img src="@/assets/images/illustration/maintenance/maintenance.svg" />
    <h1>La plateforme est actuellement en maintenance</h1>
    <p>
      Pour des raisons techniques, la plateforme est actuellement inaccessible,
      mais rassurez vous, on revient très vite !
    </p>
  </div>
</template>
